import UserTypes from "./user.types";

const INITIAL_STATE = {
    info: null,
    isDemo: false,
    token: '',
    IosAndroid: '',
    firstCheck: true
};

const userReducer = (state = INITIAL_STATE, action) => {
    switch (action.type){
        case UserTypes.SET_USER:
            return{
                ...state,
                info: action.payload
            };
        case UserTypes.REMOVE_USER:
            return{
                ...state,
                info: null
            };
        case UserTypes.SET_IS_DEMO:
            return{
                ...state,
                isDemo: action.payload
            };
        case UserTypes.GET_TOKEN:
            return{
                ...state,
                token: action.payload
            };
        case UserTypes.SET_IOS_ANDROID:
            return{
                ...state,
                IosAndroid: action.payload
            };
        case UserTypes.SEE_PWA_INFO:
            return{
                ...state,
                firstCheck: false
            };
        default:
            return state
    }
}

export default userReducer;